module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.woff2?97b9b1857a2af7322ebadc05cd406ce7";